export const DEFAULT_SORTING = { value: 'DESC', label: 'Newest Comments' };
export const SORTING_OPTIONS = [
  DEFAULT_SORTING,
  { value: 'ASC', label: 'Oldest Comments' },
  { value: 'CALL_REF_ASC', label: 'Call Time Order' }
];

export const calculateSorting = (initialValue = "DESC") => (
  SORTING_OPTIONS.find(({ value }) => value === initialValue) || DEFAULT_SORTING
);
